module.exports = __webpack_public_path__ + "img/icon_dayv2_logo.d4e5c9a9.png";